import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ChecklistIcon = function ChecklistIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ChecklistIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.712 9.133a.773.773 0 0 1 .09 1.119l-3.088 3.47a.84.84 0 0 1-.594.277.84.84 0 0 1-.614-.231l-2.059-1.984a.773.773 0 0 1 0-1.122.846.846 0 0 1 1.165 0l1.43 1.378 2.51-2.82a.845.845 0 0 1 1.16-.087M1 10.727c0-.438.369-.793.824-.793H5.94c.455 0 .824.355.824.793s-.369.794-.824.794H1.824c-.455 0-.824-.356-.824-.794M1 6.76c0-.438.369-.793.824-.793h9.264c.455 0 .824.355.824.793s-.369.794-.824.794H1.824C1.369 7.554 1 7.199 1 6.76M1 2.793C1 2.355 1.369 2 1.824 2h9.264c.455 0 .824.355.824.793s-.369.794-.824.794H1.824c-.455 0-.824-.355-.824-.794",
      clipRule: "evenodd"
    })
  }));
};

export { ChecklistIcon };
